import { memo, useEffect } from 'react';

import HistoricalCarousel from '../components/HistoricalCarousel/HistoricalCarousel';
import Loader from '../components/Loader';
import MainGrid from '../components/MainGrid';
import RankingLegend from '../components/RankingLegend';
import { useTopScorerStore } from '../store';

import GptBanner from '@shared/GptBanner';

const Main = ({ options, fromMain = true, setFromMain = undefined }) => {
  const isLoadingPlayers = useTopScorerStore((state) => state.isLoadingPlayers);
  const loadPlayersInfo = useTopScorerStore((state) => state.loadPlayersInfo);

  useEffect(() => {
    if (!fromMain) setFromMain(true);

    loadPlayersInfo();
  }, [loadPlayersInfo, fromMain, setFromMain]);

  const rankCriteria = options && options.rankCriteria;
  const showHistoricalCarousel = options && options.showHistoricalCarousel;
  const language = options && options.language;
  const advCampaign = options && options.advCampaign;

  const content = isLoadingPlayers ? (
    <Loader />
  ) : (
    <>
      <MainGrid options={options} />
      {!!rankCriteria && <RankingLegend rankCriteria={rankCriteria} />}
      {advCampaign && (
        <div role='region' className='pk-container ts-promo' pk-theme='light'>
          <div className='pk-col pk-col--span-12 pk-col--span-lg-10 pk-col--offset-lg-1'>
            <GptBanner
              slotType={`${options.advSlotType}`}
              adUnitPath={`/5874/${options.competitionBanner}.{language}/${advCampaign}`}
              position={`${options.advPosition}`}
              sponsor={`${options.sponsor}`}
            />
          </div>
        </div>
      )}
      {showHistoricalCarousel && <HistoricalCarousel language={language} />}
    </>
  );

  if (!isLoadingPlayers) window.document.body.classList.add('app-loaded');

  return <div className='ts-Main'>{content}</div>;
};

export default memo(Main);
